import { Component } from '@angular/core';

@Component({
    selector: 'app-forbidden',
    template: `<h2>Forbidden</h2>
    <p>Access to requested page not allowed.</p>`
})
export class ForbiddenComponent { }
